import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { getSessionToken } from '../context/auth/authUtils';
import { auth } from './firebase';

export const tokenQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: async (headers) => {
        try {
            const user = auth.currentUser;
            if (user) {
                const idToken = await user.getIdToken();
                headers.set('Authorization', `Bearer ${idToken}`);
                return headers;
            }
        } catch (error) {
            console.error("Failed to get Firebase ID token:", error);
        }

        const accessToken = getSessionToken();
        if (accessToken) {
            headers.set('Authorization', `Bearer ${accessToken}`);
        }

        return headers;
    },
    timeout: 30000
});
